module.exports = {"persistent":true,"storageKey":"vueI18nManager.languageCode","path":"public/i18n","defaultCode":"en","languageFilter":[],"languages":[{"name":"English","nativeName":"English","code":"en","urlPrefix":"en","translateTo":"en"},{"name":"Ukrainian","nativeName":"Українська","code":"uk","urlPrefix":"uk","translateTo":"uk"}]}


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/i18n/@config.js
// module id = 77
// module chunks = 0